// AFA Theme variables are defined here
export const afaTheme = {
  primary: '#ed5b35',
  primaryHover: '#c64524',
  primaryLight: '#f7a17e',
  secondary: '#007d82',
  secondaryHover: '#006366',
  tertiary: '#015558',
  tertiaryHover: '#014241',
  tertiaryLight: '#01babd',
  tertiaryLightHover: '#109193',
  blackNeutral: '#4a4a4a',
  greyNeutral: '#9b9b9b',
  white: '#ffffff',

  // Rebass Breakpoints (their defaul)
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  breakpoints: ['40em', '52em', '70em'],
};
